// extracted by mini-css-extract-plugin
module.exports = {"container":"blocks_container__2IRke","block":"blocks_block__3Aocu"};